import { ThumbsUp, ThumbsDown, Flag } from 'lucide-react';
import { BaseActionSheet } from './BaseActionSheet';

interface ActionSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onLike: () => void;
  onDislike: () => void;
  onReport: () => void;
}

export function ActionSheet({ isOpen, onClose, onLike, onDislike, onReport }: ActionSheetProps) {
  const actions = [
    {
      icon: ThumbsUp,
      iconColor: 'var(--chart-3)',
      bgColor: 'rgba(0, 168, 84, 0.1)',
      title: 'Quero mais pedidos assim',
      description: 'Melhorar recomendações',
      onClick: onLike,
      hoverBg: 'var(--muted)',
    },
    {
      icon: ThumbsDown,
      iconColor: 'var(--muted-foreground)',
      bgColor: 'var(--muted)',
      title: 'Não mostrar pedidos assim',
      description: 'Remover recomendações similares',
      onClick: onDislike,
      hoverBg: 'var(--muted)',
    },
    {
      icon: Flag,
      iconColor: 'var(--destructive)',
      bgColor: 'rgba(220, 38, 38, 0.1)',
      title: 'Denunciar este pedido',
      description: 'Reportar conteúdo inadequado',
      onClick: onReport,
      hoverBg: 'rgba(220, 38, 38, 0.05)',
    },
  ];

  return (
    <BaseActionSheet
      isOpen={isOpen}
      onClose={onClose}
      title="Avaliar este pedido"
      maxHeight="auto"
    >
      <div className="space-y-2">
        {actions.map((action, index) => {
          const Icon = action.icon;
          return (
            <button
              key={index}
              onClick={action.onClick}
              className="w-full flex items-center gap-4 px-4 transition-colors"
              style={{
                minHeight: '72px',
                borderRadius: 'var(--radius-card)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = action.hoverBg;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
              }}
            >
              <div
                className="flex items-center justify-center flex-shrink-0"
                style={{
                  width: '44px',
                  height: '44px',
                  backgroundColor: action.bgColor,
                  borderRadius: 'var(--radius-button)',
                }}
              >
                <Icon className="w-5 h-5" style={{ color: action.iconColor }} />
              </div>
              <div className="flex-1 text-left">
                <p
                  className="text-foreground"
                  style={{
                    fontSize: 'var(--text-base)',
                    fontWeight: 'var(--font-weight-medium)',
                    lineHeight: '1.4',
                  }}
                >
                  {action.title}
                </p>
                <p
                  className="text-muted-foreground"
                  style={{
                    fontSize: 'var(--text-sm)',
                    lineHeight: '1.4',
                    marginTop: '2px',
                  }}
                >
                  {action.description}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </BaseActionSheet>
  );
}